import Vue from "vue";
import axios from "axios";

const VP = Vue.prototype;
export default {
  setEmailSent: function({ commit }, sent) {
    commit("updateEmailSent", sent);
  },
  setQuotation: function({ commit }, user) {
    const api = location.port
      ? "http://localhost:5000/bralife/us-central1/app"
      : "https://us-central1-bralife.cloudfunctions.net/app";
    const payload = { user: user };
    const sendToBralife = new Promise((resolve, reject) => {
      resolve(axios.post(`${api}/sendQuotationToBralife`, payload));
      reject(sendToBralife());
    });
    const sendToClient = new Promise((resolve, reject) => {
      resolve(axios.post(`${api}/sendQuotationToClient`, payload));
      reject(sendToClient());
    });
    const successSent = () => {
      commit("updateSentDB", true);
      localStorage.removeItem("localSimulationState");
      localStorage.removeItem("quotationStarted");
      localStorage.removeItem("quotationStepProgress");
      localStorage.removeItem("user");
      localStorage.removeItem("emailSent");
      window.scrollTo(0,0);
      setTimeout(() => {
        location = "/";
      }, 60000); // para resetar o state;
    };

    VP.$firestore
      .collection("quotations")
      .doc()
      .set(user)
      .then(() => {
        Promise.all([sendToBralife, sendToClient]).then(res => {
          if (
            res[0].data.type === "success" &&
            res[1].data.type === "success"
          ) {
            successSent();
          } else if (res[0].data.type === "success") {
            successSent();
          }
        });
        
      })
      .catch(error => {
        console.error(error);
        console.log("Salvar dados em planilha do google");
      });
  },
  getInsurersTable: function() {
    return axios.get("/insurersTable.json");
  },
  setSimulationAge({commit}, age) {
    commit("updateSimulationAge", age);
  },
  setSimulationStarted: function({ commit }, boolean) {
    commit("updateSimulationStarted", boolean);
  },
  setSimulationSetted: function({ commit }, set) {
    commit("updateSimulationSet", set);
  },
  setSimulationValues: function({ commit }, insurers) {
    insurers.map(insurer => {
      const { id, value } = insurer;
      commit("updateSimulationValue", { id, value });
    });
  },
  setSimulationState: function({ commit }, simulation) {
    commit("updateSimulationState", JSON.parse(simulation));
  },
  setQuotationUser({commit}, user) {
    commit("updateQuotationUser", user);
  },
  setQuotationState: function({ commit }, quotation) {
    commit("updateQuotationState", JSON.parse(quotation));
  },
  setProtectionsValue: function({ commit }, value) {
    commit("updateProtectionsValue", value);
  },
  setSimulationTable: function({ commit }, tables) {
    for (let table in tables) {
      let payload = {
        id: table,
        data: tables[table]
      };
      commit("updateSimulationTable", payload);
    }
  },
  setUserState: function({ commit }, payload) {
    const {
      target: { checked, name, type, value }
    } = payload.event;
    const userState = {
      group: payload.group,
      field: name,
      value: type === "checkbox" ? checked : value
    };
    commit("updateUserState", userState);
  },
  setLocalSave: function({ commit }, payload) {
    commit("updateLocalQuotation", payload);
  },
  setQuotationStarted: function({ commit }, started) {
    commit("updateQuotationStarted", started);
  },
  setQuotationFinished({commit}, finished) {
    commit("updateQuotationFinished", finished);
  },
  setSelectedInsurer: function({ commit }, insurer) {
    commit("updateSelectedInsurer", insurer);
  },
  setQuotationStep: function({ commit }, step) {
    commit("updateQuotationStep", parseInt(step));
  },
  setQuotationProgress: function({ commit }, progress) {
    commit("updateQuotationProgress", progress);
  },
  setQuotationStepDecrement: function({ commit }) {
    commit("decrementQuotationStep");
  },
  setQuotationStepIncrement: function({ commit }) {
    commit("incrementQuotationStep");
    // const formsY = document.querySelector(".home__area--forms").offsetTop;
    // const headerHeight = document.querySelector(".header").clientHeight + 20;
    // window.scrollTo(0, formsY - headerHeight);
  },
  setNewBeneficiary: function({ commit }) {
    commit("addNewBeneficiary");
  },
  setRemoveBeneficiary: function({ commit }, index) {
    if (index > 0) {
      commit("removeBeneficiary", index);
    }
  },
  setLightbox: function({ commit }, payload) {
    commit("updateLightbox", payload);
  }
};
